import React from 'react';
import Layout from '@/components/Layout';
import { Award, Shield, Users, Zap } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

const AboutPage = () => {
  return (
    <Layout>
      <div style={{ background: 'var(--color-background)' }}>
        {/* Hero Section */}
        <section className="section-padding" style={{ background: 'var(--color-primary)' }}>
          <div className="container-custom text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ color: 'var(--color-text-on-accent)' }}>
              About Bamo Tech Sphere
            </h1>
            <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--color-text-on-accent)', opacity: 0.9 }}>
              Your trusted partner in premium technology. We don't just sell products—we build lasting relationships through quality, authenticity, and exceptional service.
            </p>
          </div>
        </section>

        {/* Mission Section */}
        <section className="section-padding">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: 'var(--color-text-primary)' }}>
                Our Mission
              </h2>
              <p className="text-lg mb-6" style={{ color: 'var(--color-text-secondary)' }}>
                At Bamo Tech Sphere, we believe technology should be accessible, reliable, and backed by people who care. Our mission is to provide Kenya with premium technology products at fair prices, coupled with service that makes you feel valued from the first click to long after your purchase.
              </p>
              <p className="text-lg" style={{ color: 'var(--color-text-secondary)' }}>
                Whether you're a student looking for your first laptop, a business seeking reliable IT infrastructure, or a professional needing cutting-edge tools—we're here to guide you to the perfect solution.
              </p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="section-padding" style={{ background: 'var(--color-background-secondary)' }}>
          <div className="container-custom">
            <h2 className="text-4xl font-bold mb-12 text-center" style={{ color: 'var(--color-text-primary)' }}>
              What We Stand For
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <Card className="luxury-card">
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <div
                      className="h-16 w-16 rounded-full flex items-center justify-center"
                      style={{ background: 'var(--color-accent)', color: 'var(--color-text-on-accent)' }}
                    >
                      <Award size={32} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-text-primary)' }}>
                    Quality First
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Every product is carefully selected and tested to meet our high standards
                  </p>
                </CardContent>
              </Card>

              <Card className="luxury-card">
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <div
                      className="h-16 w-16 rounded-full flex items-center justify-center"
                      style={{ background: 'var(--color-accent)', color: 'var(--color-text-on-accent)' }}
                    >
                      <Shield size={32} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-text-primary)' }}>
                    Authenticity Guaranteed
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    100% genuine products from authorized distributors and partners
                  </p>
                </CardContent>
              </Card>

              <Card className="luxury-card">
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <div
                      className="h-16 w-16 rounded-full flex items-center justify-center"
                      style={{ background: 'var(--color-accent)', color: 'var(--color-text-on-accent)' }}
                    >
                      <Users size={32} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-text-primary)' }}>
                    Customer First
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Your satisfaction drives everything we do, from selection to support
                  </p>
                </CardContent>
              </Card>

              <Card className="luxury-card">
                <CardContent className="p-8 text-center">
                  <div className="flex justify-center mb-6">
                    <div
                      className="h-16 w-16 rounded-full flex items-center justify-center"
                      style={{ background: 'var(--color-accent)', color: 'var(--color-text-on-accent)' }}
                    >
                      <Zap size={32} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-text-primary)' }}>
                    Fast & Reliable
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Quick delivery, responsive support, and service you can count on
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="section-padding">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: 'var(--color-text-primary)' }}>
                Why Choose Bamo Tech Sphere?
              </h2>
              <div className="space-y-6">
                <div className="p-6 rounded-xl" style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)' }}>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-accent)' }}>
                    Expert Guidance
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Our team knows technology inside and out. We'll help you find exactly what you need—no overselling, no confusion.
                  </p>
                </div>
                <div className="p-6 rounded-xl" style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)' }}>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-accent)' }}>
                    Competitive Pricing
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Premium doesn't mean overpriced. We work hard to offer the best value in Kenya's tech market.
                  </p>
                </div>
                <div className="p-6 rounded-xl" style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)' }}>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-accent)' }}>
                    Comprehensive Warranty
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Every product comes with manufacturer warranty plus our own commitment to your satisfaction.
                  </p>
                </div>
                <div className="p-6 rounded-xl" style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)' }}>
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'var(--color-accent)' }}>
                    After-Sales Support
                  </h3>
                  <p style={{ color: 'var(--color-text-secondary)' }}>
                    Our relationship doesn't end at purchase. We're here for setup help, troubleshooting, and upgrades.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default AboutPage;